import React from "react";
import capitalize from "lodash/capitalize";
import { DataTable } from "../Shared/Tabla";
import AdvancedFilter from "js/components/TablaNoticias/advancedFilter";
import { Estado } from "js/components/Shared/Tabla/TableCells";
import { editAction, viewAction } from "js/components/Shared/Tabla/ActionCells";
import AppQraphQL from "js/graphql/resolvers/noticia.resolver";
import { USER_ROLES as Roles } from "js/models/User";

const defaultHeader = (id, btnsNextTitle) => {
  return {
    title: "Noticias",
    btnsNextTitle,
    new: {
      title: "Nuevo",
      perms: [Roles.NOTICIA_W]
    },
    /* import: {
      action: AppQraphQL.mutations.importPuntosDeVenta,
      perms: [Roles.NOTICIA_W],
      variables: { idPrograma: parseInt(id, 10) },
      model: "Modelo_Puntos_de_Venta.csv"
    },*/
    export: {
      path: "noticias",
      perms: [Roles.NOTICIA_R]
    },
    queryStringMatcher: {
      idsProgramas: undefined
    }
  };
};

let columnData = [
  { id: "idNoticia", label: "ID", isNumeric: true },
  { id: "nombre", label: "Nombre" },
  {
    id: "segmentos",
    label: "Segmentos",
    type: "custom",
    parser: segmentos => {
      return segmentos && segmentos.length > 0
        ? segmentos.map(seg => seg.segmento.nombre).join(", ")
        : "--";
    }
  },
  { id: "fechaInicio", label: "Fecha Inicio", type: "date" },
  { id: "fechaFin", label: "Fecha Fin", type: "date" },
  {
    id: "IsActive",
    label: "Estado",
    type: "custom",
    parser: IsActive => {
      return IsActive ? (
        <Estado estado={capitalize("Activo")} />
      ) : (
        <Estado estado={capitalize("Inactivo")} />
      );
    }
  },
  {
    id: "usuarioCreador",
    label: "Usuario Creador",
    type: "custom",
    parser: usuarioCreador => {
      return usuarioCreador ? usuarioCreador.username : "--";
    }
  },
  { id: "actions", label: "Acciones" }
];

const simplifyHeader = {
  title: "Noticias",
  new: {
    title: "Nuevo",
    perms: [Roles.NOTICIA_W]
  },
  queryStringMatcher: {
    idsProgramas: undefined
  }
};

const defaultSort = { order: "desc", orderBy: "idNoticia" };

export const Tabla = ({ match, history }) => {
  const { id } = match.params;

  const btnsNextTitle = [];

  const edit = params => ({
    ...editAction({
      ...params,
      history,
      perms: [Roles.NOTICIA_W]
    })
  });

  const view = params => ({
    ...viewAction({ ...params, history })
  });

  return (
    <DataTable
      storage={"FiltroNoticias"}
      query={AppQraphQL.queries.getNoticias}
      defaultHeader={id ? defaultHeader(id, btnsNextTitle) : simplifyHeader}
      advancedFilter={AdvancedFilter}
      actionsCustom={[view, edit]}
      sort={defaultSort}
      columnData={columnData}
      getTipo={data => data.getNoticias}
    />
  );
};
